exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-select-image__item[data-v-1211e474]{display:inline-block;padding:5px 5px 3px;margin:5px;min-width:35px;min-height:35px;line-height:37px;color:#333;text-decoration:none;text-align:center;background-color:#fff;float:none}", ""]);

// exports
